module.exports = __webpack_public_path__ + "static/media/004.199fca3e.jpg";